import { createStore } from "redux";
import { userStyleReducer } from "./reducers/reducers";

const store = createStore(userStyleReducer);

export default store;
